import { render, staticRenderFns } from "./newSocialInsureList.vue?vue&type=template&id=26fde701&scoped=true"
import script from "./newSocialInsureList.vue?vue&type=script&lang=js"
export * from "./newSocialInsureList.vue?vue&type=script&lang=js"
import style0 from "./newSocialInsureList.vue?vue&type=style&index=0&id=26fde701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fde701",
  null
  
)

export default component.exports